import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Client } from '../services/clients.service';

function clientCategoryLabel(clientType: Client['clientType']) {
  return clientType === 'internal' ? 'Interno' : 'Externo';
}

export function ClientList({
  clients,
  isLoading,
  onSelect,
}: {
  clients: Client[];
  isLoading: boolean;
  onSelect: (id: string) => void;
}) {
  if (isLoading) {
    return <div className="py-8 text-center text-muted-foreground">Carregando...</div>;
  }

  if (!clients || clients.length === 0) {
    return (
      <div className="py-8 text-center text-muted-foreground">
        Nenhum cliente encontrado.
      </div>
    );
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Nome Fantasia</TableHead>
            <TableHead>Empresa</TableHead>
            <TableHead>Categoria</TableHead>
            <TableHead>CNPJ</TableHead>
            <TableHead>Atendimento(s)</TableHead>
            <TableHead>Contrato</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {clients.map((client) => (
            <TableRow
              key={client.id}
              className="cursor-pointer"
              onClick={() => onSelect(client.id)}
            >
              <TableCell className="font-medium">{client.tradeName || '-'}</TableCell>
              <TableCell>{client.company?.name || '-'}</TableCell>
              <TableCell>
                <Badge variant="outline" className="font-normal">
                  {clientCategoryLabel(client.clientType)}
                </Badge>
              </TableCell>
              <TableCell>{client.cnpj || '-'}</TableCell>
              <TableCell>
                {client.attendantsSummary || '-'}
              </TableCell>
              <TableCell>
                <Badge variant={client.hasActiveContract ? 'default' : 'secondary'}>
                  {client.hasActiveContract ? 'Tem contrato' : 'Sem contrato'}
                </Badge>
              </TableCell>
              <TableCell>
                <Badge variant={client.isActive ? 'default' : 'secondary'}>
                  {client.isActive ? 'Ativo' : 'Inativo'}
                </Badge>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
